import { render, staticRenderFns } from "./SvnFlowDetail.vue?vue&type=template&id=06ba911e&scoped=true&"
import script from "./SvnFlowDetail.vue?vue&type=script&lang=js&"
export * from "./SvnFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./SvnFlowDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SvnFlowDetail.vue?vue&type=style&index=1&id=06ba911e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba911e",
  null
  
)

export default component.exports